"use client";

import React, { useState } from "react";
import { FiCheckCircle } from "react-icons/fi";

const PlanCard = ({
  title,
  validity,
  price,
  oldPrice,
  discount,
  features,
  isActive,
  onCardClick,
  onPlanClick
}) => (
  <div
    onClick={onCardClick}
    className={`bg-white rounded-[10px] p-6 md:p-8 flex flex-col items-center flex-1 shadow-sm transition-all border cursor-pointer
      ${isActive
        ? "border-[#4096F6] border-2 relative lg:scale-105 z-10"
        : "border-[#E0E0E0]"
      }`}
  >
    <h3 className="text-[20px] tracking-tight font-[600] text-[#000000] mb-1 font-inter text-center">
      {title}
    </h3>

    <p className="text-[13px] md:text-[16px] text-[#000000] mb-6 font-[500] font-inter text-center">
      Valid for {validity}
    </p>

    <div className="flex flex-wrap justify-center items-center gap-2 md:gap-3 mb-6">
      <span className="text-[28px] font-[600] text-[#4096F6] font-inter">
        ₹{price}
      </span>
      <span className="text-[16px] md:text-[21px] text-[#33333380] line-through font-inter">
        ₹{oldPrice}
      </span>
      <span className="bg-[#DAB820] text-white text-[10px] md:text-[16px] font-[500] px-3 md:px-4 py-[8px] rounded-full uppercase font-inter whitespace-nowrap">
        {discount} OFF
      </span>
    </div>

    <div className="w-full h-[1.5px] bg-[#333] mb-6 md:mb-8"></div>

    <ul className="w-full space-y-3 md:space-y-4 mb-8 md:mb-10">
      {features.map((feature, i) => (
        <li
          key={i}
          className="flex items-start gap-3 pb-2 text-[13px] md:text-[18px] text-[#000000] font-[500] border-b border-dashed border-[#000000] last:border-0 font-inter text-left leading-tight"
        >
          <FiCheckCircle className="text-[#21C11E] text-[18px] shrink-0 mt-0.5" />
          {feature}
        </li>
      ))}
    </ul>

    <button
      onClick={(e) => {
        e.stopPropagation(); // card click se alag rahe
        onPlanClick({ title, validity, price, oldPrice, discount, features });
      }}
      className="w-full bg-[#4096F6] hover:bg-[#2563EB] text-white text-[18px] tracking-tight py-3 transition-colors mt-auto font-inter font-[500] shadow-sm cursor-pointer active:scale-95"
    >
      Select {title.split(" ")[0]} Plan
    </button>
  </div>
);

const SubscriptionPlans = ({ plans = [], loading, onPlanClick }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  if (loading) {
    return <div className="text-center py-20">Loading plans...</div>;
  }

  if (!plans.length) {
    return <div className="text-center py-20">No plans available</div>;
  }
  // const plans = [
  //   {
  //     title: "Monthly Subscription",
  //     validity: "31 Days",
  //     price: 99,
  //     oldPrice: 599,
  //     discount: "83%",
  //     features: [
  //       "70,000+ Mock Tests",
  //       "Unlimited Practice Questions",
  //       "17,000+ Previous Year Papers",
  //       "Unlimited Re-attempt Mode"
  //     ]
  //   },
  //   {
  //     title: "Yearly Subscription",
  //     validity: "365 Days",
  //     price: 799,
  //     oldPrice: 4599,
  //     discount: "83%",
  //     features: [
  //       "All Monthly Features",
  //       "Unlimited Pro Live Tests",
  //       "Priority Support",
  //       "Personalized Study Plan"
  //     ]
  //   },
  //   {
  //     title: "Yearly Prime Subscription",
  //     validity: "365 Days",
  //     price: 799,
  //     oldPrice: 6499,
  //     discount: "88%",
  //     features: [
  //       "All Monthly Features",
  //       "Unlimited Pro Live Tests",
  //       "Priority Support",
  //       "Personalized Study Plan",
  //       "Advanced Analytics"
  //     ]
  //   }
  // ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16 items-stretch">
      {plans.map((p, i) => (
        <div key={p._id || i} className="h-full flex">
          <PlanCard
            title={p.title}
            validity={`${p.validityDays} Days`}
            price={p.price}
            oldPrice={p.originalPrice}
            discount={`${p.discountPercent || 0}%`}
            features={p.features}
            isActive={activeIndex === i}
            onCardClick={() => setActiveIndex(i)}
            onPlanClick={() => onPlanClick(p)}
          />
        </div>
      ))}
    </div>
  );
};

export default SubscriptionPlans;
